module.exports = __webpack_public_path__ + "static/media/cadeado.fc3d12b3.png";